export enum CustomEventsEnum {
    COOKIE_BAR_CLOSED = 'cookie-bar-closed',
}
